import { compare } from "@thi.ng/compare";
import { identity } from "@thi.ng/compose";
/**
 * Helper function to inject default {@link SortOpts}.
 *
 * @param opts -
 *
 * @internal
 */
export const __sortOpts = (opts) => (Object.assign({ key: identity, compare }, opts));
